<template>
<div class="content-main">
  <!-- side -->
  <div class="side-content-wrapper" v-if="$slots.sideContent !== undefined" :style="sideContentWrapperStyle">
    <div class="title">
      <div v-if="$slots.title === undefined">
        {{sideTitle}}
      </div>
      <slot v-else name="title" />
    </div>
    <div v-if="defaultSide === true" class="side-content">
      <el-scrollbar class="bar-visible">
        <slot name="sideContent"/>
      </el-scrollbar>
    </div>
    <slot v-else name="sideContent"/>
  </div>
  <!-- content -->
  <div class="main-content-wrapper" :style="mainContentWrapperStyle">
    <el-scrollbar v-if="defaultContent === true" :ref="scrollbarRef">
      <div class="content">
        <slot name="content" />
      </div>
    </el-scrollbar>
    <w-scroll-top-button v-if="defaultContent === true" :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
    <slot v-else name="content" />
  </div>
</div>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WSettingsContentTemplate',
  mixins: [ScrollbarMixin],
  props: {
    sideTitle: {
      type: String,
    },
    sideWidth: {
      type: String,
    },
    defaultContent: {
      type: Boolean,
      default: true,
    },
    defaultSide: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    sideContentWrapperStyle() {
      if (!isEmpty(this.sideWidth)) {
        return {
          width: this.sideWidth,
        };
      }
      return null;
    },
    mainContentWrapperStyle() {
      if (!isEmpty(this.sideWidth)) {
        return {
          width: `calc(100% - ${this.sideWidth})`,
        };
      }
      return null;
    },
  },
  mounted() {
    this.setScrollData();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/template/SettingsContentTemplate.vue